import { ConfirmationOptions } from 'primevue/confirmationoptions';
import { Vue } from 'vue-class-component';

/** Helper function to handler beforeRouteLeave based on whether there are changes */
export function allowLeaveOnlyWithConfirmationOrNoChanges(currentVue: Vue, hasChanges: boolean, next: (arg?: boolean) => void): void {
	if (!hasChanges) {
		next()
	}
	else {
		currentVue.$confirm.require({
			header: 'Leave without saving?',
			message: 'Are you sure you want to navigate away from this form without saving first?\nThere appear to be unsaved changes.',
			// icon: 'pi pi-question',
			accept: () => {
				next()
			},
			reject: () => {
				next(false)
			}
		} as ConfirmationOptions);
	}
}